import React, { useState, useRef } from 'react'
import { signIn, signUp } from '../lib/supabase'

export default function Auth() {
  const [mode, setMode] = useState('login')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [username, setUsername] = useState('')
  const [fullName, setFullName] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const emailRef = useRef(null)
  const passwordRef = useRef(null)

  const handleSubmit = async () => {
    const emailVal = email || emailRef.current?.value
    const passwordVal = password || passwordRef.current?.value
    setError(''); setLoading(true)
    try {
      if (mode === 'login') {
        await signIn(emailVal, passwordVal)
      } else {
        if (!username.trim()) { setError('Βάλε username'); setLoading(false); return }
        await signUp(emailVal, passwordVal, username.trim(), fullName.trim())
      }
    } catch (e) {
      setError(e.message || 'Κάτι πήγε στραβά')
    }
    setLoading(false)
  }

  return (
    <div className="auth-page">
      <div className="auth-logo">🎹</div>
      <div className="auth-title" style={{ color: 'var(--text)' }}>JazzPractice</div>
      <div className="auth-subtitle">
        {mode === 'login' ? 'Καλωσήρθες πίσω' : 'Ξεκίνα το ταξίδι σου'}
      </div>
      <div className="auth-form">
        {mode === 'register' && (
          <>
            <input className="input" placeholder="Όνομα (προαιρετικό)" value={fullName} onChange={e => setFullName(e.target.value)} />
            <input className="input" placeholder="Username *" value={username} onChange={e => setUsername(e.target.value)} />
          </>
        )}
        <input ref={emailRef} className="input" placeholder="Email" type="email" autoComplete="off" value={email} onChange={e => setEmail(e.target.value)} />
        <input ref={passwordRef} className="input" placeholder="Password" type="password" autoComplete="off" value={password} onChange={e => setPassword(e.target.value)} onKeyDown={e => e.key === 'Enter' && handleSubmit()} />
        {error && <div className="auth-error">{error}</div>}
        <button className="btn-primary" onClick={handleSubmit} disabled={loading}>
          {loading ? '...' : mode === 'login' ? 'Είσοδος' : 'Εγγραφή'}
        </button>
        <div className="auth-switch">
          {mode === 'login' ? (
            <>Νέος χρήστης; <button onClick={() => setMode('register')}>Εγγράψου</button></>
          ) : (
            <>Έχεις ήδη λογαριασμό; <button onClick={() => setMode('login')}>Σύνδεση</button></>
          )}
        </div>
      </div>
      <div className="auth-motto">
        "Όσο μεγαλύτερο είναι το όνειρο, τόσο πιο σημαντική είναι η ομάδα"
      </div>
    </div>
  )
}
